<template>
  <div class="dropdown" :class="{collapsed: collapsed}" v-on-clickaway="onClose">
    <div class="dropdown__btn" :class="btnClass" @click="onToggle">
      <slot name="btn"></slot>
    </div>
    
    <transition name="dropdown">
      <div class="dropdown__content" v-if="collapsed">
        <button class="btn btn--mobile-close" @click="onClose"><span class="icon-remove"></span></button>
        <slot name="content"></slot>
      </div>
    </transition>
  </div>
</template>


<script>
  import { mixin as clickaway } from 'vue-clickaway'

  export default {
    name: 'dropdown',

    mixins: [ clickaway ],

    data () {
      return {
        collapsed: false
      }
    },

    props: {
      btnClass: {
        type: String,
        required: false,
        default: ''
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    methods: {
      onToggle () {
        return this.disabled
          ? true
          : (this.collapsed = !this.collapsed)
      },

      onClose () {
        this.collapsed = false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// DropdownSimple.vue?6bd9db72